import React from 'react';
import TextField from '@material-ui/core/TextField';
import {Translate} from "../../../config/Translate";
import {withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../config/design/styles";
import {connect} from "trim-redux";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import {languages} from "../../../config/values";

class SpecialtiesField extends React.Component {
    state={
        language:this.props.init
    };
    handleChangeLanguage(e){
        this.setState({
            language:e.target.value
        })
        this.props.handleLanguage(e.target.value);
    }
    async componentDidUpdate(prevProps){
        if(this.state.language !== this.props.init){
            this.setState({
                language: this.props.init,
            })
        }
    }
    render(){
        let {language} = this.state;
        return (
            <TextField
                select
                fullWidth
                size={this.props.size? this.props.size : 'small'}
                label={Translate.chooseLanguage}
                value={language}
                onChange={this.handleChangeLanguage.bind(this)}
                variant="outlined"
            >
                {languages.map((option,index) => (
                    <MenuItem key={index} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </TextField>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(SpecialtiesField))));